<template>
  <div class="detail-item">
    <slot name="icon">
      <app-material-icon :name="icon" data-locator="icon" size="xs" />
    </slot>
    <dt class="text--bold text-text-secondary" data-locator="title">{{ $t(title) }} :</dt>
    <dd class="text-text-secondary" data-locator="content">
      <slot></slot>
    </dd>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

export default defineComponent({
  name: 'AppGridDetailItem',
  props: {
    icon: {
      type: String as PropType<string>,
      default: '',
    },
    title: {
      type: String as PropType<string>,
      default: '',
    },
  },
})
</script>

<style scoped lang="scss">
.detail-item {
  column-gap: 6px;
  display: flex;
  align-items: center;

  dd, dt {
    display: flex;
    align-items: center;
    column-gap: 4px;
  }
}
</style>
